import React from "react";
import { formatDistance } from "date-fns";
import { SharedReportLinkRecipient } from "../../../../../types";
import styles from "./recipientsTable.module.scss";

type RecipientInfoProps = {
  recipient: SharedReportLinkRecipient;
};

const RecipientInfo = ({
  recipient,
}: RecipientInfoProps): React.JSX.Element => {
  return (
    <>
      <strong>{recipient.email}</strong>
      <div className={styles["recipient-viewed-text"]}>
        {recipient.last_opened ? (
          <>
            Viewed the report link{" "}
            <strong>
              {formatDistance(new Date(recipient.last_opened), new Date(), {
                addSuffix: true,
              })}
            </strong>
          </>
        ) : (
          <>
            <strong>Hasn&apos;t viewed</strong> the report link
          </>
        )}
      </div>
    </>
  );
};

export default RecipientInfo;
